import ArrowDown from './src/arrow-down-combined';
export default ArrowDown;